module.exports = __webpack_public_path__ + "img/gie-min.db0ceb01.svg";